var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21H16M12 17V21M14.5 3H17.7997C18.9198 3 19.4798 3 19.9076 3.21799C20.284 3.40973 20.5899 3.71569 20.7817 4.09202C20.9997 4.51984 20.9997 5.07989 20.9997 6.2V13.8C20.9997 14.9201 20.9997 15.4802 20.7817 15.908C20.5899 16.2843 20.284 16.5903 19.9076 16.782C19.4798 17 18.9198 17 17.7997 17H6C5.06812 17 4.60218 17 4.23463 16.8478C3.74458 16.6448 3.35523 16.2554 3.15224 15.7654C3 15.3978 3 14.9319 3 14M7 2V2.41667M7 11.5835V12.0002M11.9997 7H11.583M2.41667 7H2M10.5349 3.46453L10.2402 3.75916M3.75947 10.2408L3.46484 10.5354M3.46514 3.46477L3.75977 3.7594M10.2415 10.241L10.5361 10.5356M9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon-9.2441a84303c88145a4dda35d24d7e45d.svg";
export { ForwardRef as ReactComponent };